import { StakeholderService } from 'src/app/core/services/stakeholder.service';
import { CaseStakeholder } from '@secca/shared/models/caseStakeholder';
import { CaseHistoryCommEntry } from '@secca/shared/models/caseHistoryEntry';
import { Component, Input, Inject } from '@angular/core';
import { CommunicationDirection, MessageChannelType, PermissionEnum, PermissionHideTypeEnum } from '@secca/shared/models/enums';
import { OutputManagementService } from '../../case-output-management/services/output-management.service';
import { Message } from '../../case-output-management/models/message';
import { PhoneDto } from '@secca/shared/models/phone-dto';
import { CaseLockHelperService } from '@secca/core/services/case-lock-helper.service';
import { ServiceOrderMessageRequest } from '@secca/shared/models/service-order/service-order-message-request';
import { CaseMessageService } from '@secca/core/services/case-message.service';
import { PermissionService } from '@secca/core/services/permission.service';
import { DialogViewerServiceInterface } from '@secca/core/services/dialog-viewer-service-interface';
import { DIALOG_VIEWER_TOKEN } from '@secca/core/services/token';
import { Case } from '@secca/shared/models/case';
import { CaseStateService } from '@secca/core/state-services/case-state.service';
import { CaseDialogViewerService } from '@secca/case/case-dialog-viewer.service';
import { CaseService } from '@secca/core/services/case.service';
import {ModalDialogComponent} from '@secca/shared/components/modal-dialog/modal-dialog.component';
import {ModalDialogConfiguration} from '@secca/shared/models/modal/modal-dialog-configuration';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import { LockContextEnum } from '@secca/shared/enums/lock-context.enum';

@Component({
    selector: 'app-case-summary-sms',
    templateUrl: './case-summary-sms.component.html',
    styleUrls: ['./case-summary-sms.component.scss'],
    standalone: false
})
export class CaseSummarySmsComponent {
  @Input()
  case: Case;

  @Input() showActionButton: boolean;
  @Input() set entry(entry: CaseHistoryCommEntry) {
    if (entry) {
      this._entry = entry;
      this.tryToMatchStakeholder();
    }
  }
  get entry(): CaseHistoryCommEntry {
    return this._entry;
  }
  _entry: CaseHistoryCommEntry;

  @Input()
  set stakeholders(stakeholders: CaseStakeholder[]) {
    if (stakeholders) {
      this._stakeholders = stakeholders;
      this.tryToMatchStakeholder();
    }
  }
  get stakeholders(): CaseStakeholder[] {
    return this._stakeholders;
  }
  _stakeholders: CaseStakeholder[];
  showEntryMenu: boolean;
  stakeholder: CaseStakeholder;
  deleteReason: string;

  constructor(
    private outputManagementService: OutputManagementService,
    private stakeholderService: StakeholderService,
    public caseLockHelperService: CaseLockHelperService,
    public permissionService: PermissionService,
    private caseMessageService: CaseMessageService,
    public caseStateService: CaseStateService,
    private dialogViewerService: CaseDialogViewerService,
    private modalService: NgbModal,
    private caseService: CaseService
  ) {}

  get stakeholderName() {
    if (this.stakeholder) {
      if (this.stakeholder.isCompany) {
        return this.stakeholder.company.name;
      } else {
        return this.stakeholder.person.firstName + ' ' + this.stakeholder.person.surname;
      }
    }
  }

  get deleted(): boolean {
    return !!this.entry?.deletedBy;
  }

  get CommunicationDirection() {
    return CommunicationDirection;
  }

  get stakeholderIcon() {
    if (this.stakeholder) {
      return this.stakeholderService.getStakeholderIconFullPath(this.stakeholder.stakeholderType);
    }
  }

  viewMenuClick() {
    this.dialogViewerService.openCaseSummarySmsDialog(this.entry, this.stakeholder, this.case.caseNumber);
  }

  replyMenuClick() {
    const msg = new Message({
      caseId: this.entry.caseId.toString(),
      channelDisabled: true,
      messageChannelType: MessageChannelType.SMS,
      stakeholderReceiverId: this.stakeholder == null ? null : +this.stakeholder.id,
      sms: new PhoneDto(),
    });

    this.outputManagementService.openMessageWindow(
      this.entry.caseId.toString(),
      new ServiceOrderMessageRequest({ message: msg, messageService: this.caseMessageService })
    );
  }

  deleteMenuClick() {
    if (!!this.entry.messageId) {
      this.caseMessageService.deleteCaseMessageIdWithDeleteReason(this.entry.messageId, this.deleteReason)
        .subscribe(s => {
          this.caseService.publishCaseNotesChanges(+this.case.id);
        });
    } else {
      this.caseMessageService.deleteCaseMessageHistoryWithDeleteReason(this.case.id, this.entry.id, this.deleteReason)
        .subscribe(s => {
          this.caseService.publishCaseNotesChanges(+this.case.id);
        });
    }
  }

  private tryToMatchStakeholder(): void {
    if (this.stakeholders != null && this.entry != null) {
      if (this.entry.direction === CommunicationDirection.IN_BOUND) {
        this.stakeholder = this.stakeholders.find(a => +a.id === this.entry.stakeholderSenderId);
      }
      if (this.entry.direction === CommunicationDirection.OUT_BOUND) {
        this.stakeholder = this.stakeholders.find(a => +a.id === this.entry.stakeholderReceiverId);
      }
    }
  }

  get PermissionEnum() {
    return PermissionEnum;
  }

  get PermissionHideTypeEnum() {
    return PermissionHideTypeEnum;
  }

  get LockContextEnum() {
    return LockContextEnum;
  }

  openModal() {

    const modalRef = this.modalService.open(ModalDialogComponent);
    modalRef.componentInstance.configuration = new ModalDialogConfiguration({
      header: 'default-modal-header',
      title: 'case-summary-modal-gdpr-delete',
      text: '',
      footer: 'case-summary-modal-gdpr-delete-proceed',
      showYesNoButton: false,
      yes: 'Yes',
      no: 'No',
      labelTextAboveTextArea: 'case-summary-modal-gdpr-delete-reason-label',
      placeholderText: 'case-summary-modal-gdpr-delete-reason-placeholder',
      showTextAreaWithYesNo: true,
      showTextArea: true,
      isBody: true,
      isFooter: true,
      modalYesHoverDialog: 'case-summary-modal-gdpr-delete-yes-hover'
    });

    modalRef.componentInstance.saveandcloseEvent.subscribe(
      emittedEvent => {
        this.closeModal();
        if (emittedEvent) {
          this.deleteReason = emittedEvent;
          console.log(this.deleteReason);
          this.deleteMenuClick();
        }
      },
      error => { }
    );

    modalRef.componentInstance.closeModalEvent.subscribe(
      emittedEvent => {
        this.closeModal();
      },
      error => console.log('error', error)
    );
  }

  closeModal() {
    this.modalService.dismissAll();
  }
}
